import { useState, useEffect } from 'react';
import { fetchProfiles } from '../services/profileService';

// Custom hook for managing profile data fetching and state
export const useProfiles = () => {
  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadProfiles = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await fetchProfiles();
        setProfiles(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadProfiles();
  }, []);

  return { profiles, loading, error };
};
